export default function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}



// WEBPACK FOOTER //
// ./node_modules/moment/src/lib/utils/has-own-prop.js